import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Person, Public } from '@mui/icons-material';
import { COLOR } from '../ui/tokens';

export const COOP_MODES = [
    { value: 'solo', label: 'Solo', icon: Person },
    { value: 'coop', label: 'Online Co-op', icon: Public },
];

/** Solo / Online Co-op picker for game page headers; locked while a room is live. */
export default function CoopModePicker({
    value, onChange, accentColor = COLOR.primary, disabled = false, testId = 'coop-mode-picker',
}) {
    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            value={value}
            aria-label="Game mode"
            data-testid={testId}
            onChange={(_, v) => { if (v && v !== value) onChange(v); }}
        >
            {COOP_MODES.map(({ value: mode, label, icon: Icon }) => (
                <ToggleButton
                    key={mode}
                    value={mode}
                    disabled={disabled && value !== mode}
                    sx={{
                        color: COLOR.textMuted,
                        textTransform: 'none',
                        gap: 0.75,
                        '&.Mui-selected': { color: COLOR.text, borderColor: accentColor },
                    }}
                >
                    <Icon fontSize="small" />
                    {label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
